<template>
    <byted-popover
      width="240px"
      transfer
      :disabled="!disable"
      trigger="hover"
      class="cascader-popover"
    >
      <template slot="body">{{ toolTip }}</template>
      <byted-cascader
        slot="reference"
        class="report-cascader"
        :options="options"
        :placeholder="$bp_t('请选择', 'common.please_choose')"
        :value="value"
        :multiple="true"
        :disabled="disable"
        collapse-tags
        @change="selectChangeHandler"
      ></byted-cascader>
    </byted-popover>
</template>

<script>
export default {
  name: 'report-cascader',
  props: {
    optionList: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    disable: {
      type: Boolean,
      default: false
    },
    toolTip: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      options: [],
    }
  },
  methods: {
    selectChangeHandler(val) {
      this.$emit('valueChanged', val)
    }
  },
  mounted() {
    this.options = this.optionList.map(option => {
      if (option.children) {
        return option;
      }
      return {
        ...option,
        renderLabel: function(name) {
          return (
            <byted-tooltip
              placement="right"
              width="auto"
              transfer
            >
              {name}
              <div slot="reference" class="ref-word">{name}</div>
            </byted-tooltip>
          )
        }
      }
    })
  }
};
</script>

<style lang="scss" scoped>
.cascader-popover {
  /deep/ .bui-cascader-menus
    .bui-cascader-menu-item
    .bui-cascader-custom-render-item
    .byted-popover-wrapper
    .ref-word {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 160px;
    height: 18px;
  }
}
</style>